// extracted by mini-css-extract-plugin
export default {"edit-input-box":"j2UPg_edit-input-box"};